import { graphql } from '../../../graphql/generated';

export const PARAMETERS_QUERY = graphql(`
  query Parameters($labId: ID!) {
    labParameters(labId: $labId) {
      id
      longName
      shortName
      specimens {
        id
        name
        classification
      }
      analysisStations {
        id
        name
      }
      withParameters {
        id
        shortName
      }
      withoutParameters {
        id
        shortName
      }
      specialRates {
        id
        shortName
      }
      forms {
        id
        name
      }
      deactivated
      doctorBilling
      patientBilling
      description
      billingDescription
      importantDescription
      edifactNumber
      link
      lgDoctorBilling
      storagePeriod
      evalHours
      priceDoctor
      priceLgDoctor
      pricePatient
      priceDeductible
      partnerLab
      synonyms
      acute
      volume
      loincCode
      aiDescription
    }

    lab(id: $labId) {
      id
      pl1Name
      pl2Name
      pl3Name
      pl4Name
      pl5Name
    }
  }
`);
